module.exports = __webpack_public_path__ + "assets/images/01_d991c7e846145e46b8fe507a7263b7a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-three/exercise-4/01.png
// module id = 248
// module chunks = 0